import 'jquery-ui/ui/widgets/slider';

export default {
    init() {
        // JavaScript to be fired on archive pages

    },
    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};
const loader = '<svg xmlns="http://www.w3.org/2000/svg" class="loader" xmlns:xlink="http://www.w3.org/1999/xlink" style="display: block; shape-rendering: auto;" width="200px" height="200px" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid"><g transform="translate(80,50)"><g transform="rotate(0)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="1"> <animateTransform attributeName="transform" type="scale" begin="-0.875s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.875s"></animate></circle></g></g><g transform="translate(71.21320343559643,71.21320343559643)"><g transform="rotate(45)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.875"> <animateTransform attributeName="transform" type="scale" begin="-0.75s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.75s"></animate></circle></g></g><g transform="translate(50,80)"><g transform="rotate(90)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.75"> <animateTransform attributeName="transform" type="scale" begin="-0.625s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.625s"></animate></circle></g></g><g transform="translate(28.786796564403577,71.21320343559643)"><g transform="rotate(135)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.625"> <animateTransform attributeName="transform" type="scale" begin="-0.5s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.5s"></animate></circle></g></g><g transform="translate(20,50.00000000000001)"><g transform="rotate(180)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.5"> <animateTransform attributeName="transform" type="scale" begin="-0.375s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.375s"></animate></circle></g></g><g transform="translate(28.78679656440357,28.786796564403577)"><g transform="rotate(225)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.375"> <animateTransform attributeName="transform" type="scale" begin="-0.25s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.25s"></animate></circle></g></g><g transform="translate(49.99999999999999,20)"><g transform="rotate(270)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.25"> <animateTransform attributeName="transform" type="scale" begin="-0.125s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="-0.125s"></animate></circle></g></g><g transform="translate(71.21320343559643,28.78679656440357)"><g transform="rotate(315)"><circle cx="0" cy="0" r="5" fill="#d10018" fill-opacity="0.125"> <animateTransform attributeName="transform" type="scale" begin="0s" values="1.5 1.5;1 1" keyTimes="0;1" dur="1s" repeatCount="indefinite"></animateTransform> <animate attributeName="fill-opacity" keyTimes="0;1" dur="1s" repeatCount="indefinite" values="1;0" begin="0s"></animate></circle></g></g><!-- [ldio] generated by https://loading.io/ --></svg>';


$('#price-slider').slider({
    range: true,
    min: parseInt( $('#price-slider').data('min') ),
    max: parseInt( $('#price-slider').data('max') ),
    step: 10,
    values: [$('#price_min').val(), $('#price_max').val()],
    slide: function(event, ui) {
        $('#price_min').val(ui.values[0]);
        $('#price_max').val(ui.values[1]);
        $('.ui-slider-handle:eq(0) .price-slider__min').html( 'от ' + ui.values[0] );
        $('.ui-slider-handle:eq(1) .price-slider__max').html(  'до ' + ui.values[1] );
    },
    /* eslint-disable */
    create: function(event, ui) {
        $('.ui-slider-handle:eq(0)', this).append( `<span class="price-slider__min">${ajax.from} ${$('#price_min').val()}</span>` );
        $('.ui-slider-handle:eq(1)', this).append( `<span class="price-slider__max">${ajax.to} ${$('#price_max').val()}</span>` );
    },
    /* eslint-enable */

});
$('#price_min').on('input', function() {
    if ( parseInt( $(this).val() ) < parseInt( $('#price_max').val() ) ) {
        $('#price-slider').slider('values', [$(this).val(), $('#price_max').val()]);
        $('.ui-slider-handle:eq(0) .price-slider__min').html('от ' + $(this).val());
    }
    console.log($(this).val());
});
$('#price_max').on('input', function() {
    if ( parseInt( $(this).val() ) > parseInt( $('#price_min').val() ) ) {
        $('#price-slider').slider('values', [ $('#price_min').val() ,$(this).val() ]);
        $('.ui-slider-handle:eq(1) .price-slider__max').html(  'до ' + $(this).val() );
    }
});
$('.js-shop-filter').submit(function(e) {
    e.preventDefault();

    let formArray = $(this).serialize();
    let topFormArray = $('.archive-product__top-filter').serialize();
    if ( topFormArray )
        formArray = formArray + '&' + topFormArray;
    $('#offset_page').val(0)

    var filterData = {
        action: 'shop_filter',
        filters: formArray,
        offset: 0,
    }

    if ( $(window).width() < 767 ) {
        $('.archive-product__filter, .filter-overlay').removeClass('active');
    }

    /* eslint-disable */
    $.ajax({
        type: 'POST',
        url: ajax.ajaxurl, // admin-ajax.php
        data: filterData,
        beforeSend: function () {
            // what to do just after the form has been submitted
            $('.archive-product__main .products').empty().append(loader);
        },
        success: function (response) {

            response = JSON.parse(response);

            $(window).data('ajaxready', true)
            $('.archive-product__main .products').append(response['products']);
            window.history.pushState({}, '', '?' + formArray);

            if ( response['offset'] != false ) {
                $('#offset_page').val(response['offset']);
            }
            if ( parseInt(response.product_count) < 16 ) {
                $('.js-load-more').addClass('d-none');
            } else {
                $('.js-load-more').removeClass('d-none');
            }

            $('.archive-products__pagination').html( response['pagination'] );
        },
        complete: function () {
            $('.archive-product__main .products').find('.loader').remove()
        },
    })
    /* eslint-enable */

})

$(document).on('click', '.js-archive-pagination a', function(e) {
    e.preventDefault();
    let offset = parseInt( $(this).attr('href').split('#')[1] ) - 1;
    $('#offset_page').val( offset );

    let searchParams = new URLSearchParams(window.location.search);

    console.log($('#product_category').length, $('#product_category').val())
    // Add or update search parameters
    if ($('#product_category').length > 0) {
        searchParams.set('product_category', $('#product_category').val());
    }

    console.log('searchParams', searchParams)
    let data = {
        action: 'shop_filter',
        filters: searchParams.toString(),
        offset: $('#offset_page').val() == 0 ? 1 : $('#offset_page').val(),
    }
    console.log('data', data)

    infinite_scroll_products(data, 'insert');
})

$('.js-load-more').click(function(e) {
    e.preventDefault();

    let filter = window.location.search;
    if ( !(filter.length > 1) ) {
        filter = $('.js-shop-filter').serialize() + '&'+ $('.archive-product__top-filter').serialize();
    }

    let data = {
        action: 'shop_filter',
        filters: filter,
        offset: $('#offset_page').val() == 0 ? 1 : $('#offset_page').val(),
    }

    console.log('filters', data)

    infinite_scroll_products(data, 'append');
})

$('.js-sort-select').change(function() {
    $('#orderby').val($(this).val());
    $('.js-shop-filter').submit();
})

/* eslint-disable */
function infinite_scroll_products(data, insertType) {
    $(window).data('ajaxready', false);
    console.log(ajax.ajaxurl);
    $.ajax({
        url: ajax.ajaxurl, // admin-ajax.php
        type: 'POST',
        data: data,
        beforeSend: function() {
            $('.archive-product__main .products').append(loader);
        },
        complete: function() {
            $('.loader').remove();
        },
        success: function(response) {
            console.log(response);
            response = JSON.parse(response);
            console.log(response);

            if ( parseInt(response.product_count) < 16 ) {
                $('.js-load-more').addClass('d-none');
            } else {
                $('.js-load-more').removeClass('d-none');
            }

            if ( !response.offset ) {
                $(window).data('ajaxready', false);
            } else {

                $(window).data('ajaxready', true);
                $('#offset_page').val(response['offset']);
                if ( insertType == 'append' ) {
                    $('.archive-product__main .products').append(response['products']);
                } else if ( insertType == 'insert' ) {
                    $('.archive-product__main .products').html( response['products'] );
                }
                $('.archive-products__pagination').html( response['pagination'] );

            }
        },
    });
}
/* eslint-enable */
if ( $(window).width() < 767 ) {
    $('.archive-product__filter-inner').prepend( $('.archive-product__top-filter') );
}

$(window).resize(function() {
    if ( $(window).width() < 767 ) {
        $('.archive-product__filter-inner').prepend( $('.archive-product__top-filter') );
    } else {
        $('.archive-product__top-filter-wrap').prepend( $('.archive-product__top-filter') );
    }
})
